module.exports = __webpack_public_path__ + "/images/cover-recibiendo-dinero-es.decaf49.png";